import React, { useContext } from "react";
import CustomPagination from "../../../components/Pagination/CustomPagination";
import "./QueueDetail.css";
import { formDataContext } from "../BillingDetail";
import * as Constants from '../../../utils/Constants';
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Grid from "@mui/material/Grid";
import { ConvertDatetoFormatdateNormal } from "../../../utils/DateUtil";
import { PhotoCameraOutlined } from '@mui/icons-material';
const QueueDetail = (props) => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const {
    page,
    setPage,
    pageSize,
    setPageSize,
    totalRecordCount,
    setTotalRecordCount,
    isClickSearch,
    setIsClickSearch,
    pageCount,
    getBillingRs,
  } = useContext(formDataContext);

  const headersGroup = [
    {
      headerName: t("ProductList"),
      size: "50%",
      headerAlign: "center",
    },
    {
      headerName: t("TotalNumber"),
      size: "25%",
      headerAlign: "center",
    },
    {
      headerName: t("SuccessesNumber"),
      size: "25%",
      headerAlign: "center",
    },
  ];

  const TextDetail = ({
    title,
    value,
    titleWidth,
    color,
    valueWidth,
    valueAlign,
    titleAlign,
    icon,
  }) => (
    <div style={{ width: "100%", color: color ?? "black" }}>
      <Grid container style={{ display: "flex", gap: "15px" }}>
        <Grid
          style={{
            width: titleWidth ?? "auto",
            textAlign: titleAlign ?? "right",
          }}
        >
          <span style={{ fontWeight: "bold" }}>{`${title} :`}</span>
        </Grid>
        <Grid
          style={{
            width: valueWidth ?? "auto",
            display: "flex",
            justifyContent: valueAlign ?? "",
            textAlign: "right",
            gap:"20px"
          }}
        >
          <span>{`${value}`}</span>
          {icon}
        </Grid>
      </Grid>
    </div>
  );

  const getPictureStatusDesc = (status) => {
    switch (status) {
        case Constants.Status.Yes:
            return t('Pass');
        case Constants.Status.No:
            return t('NotPass');
        case Constants.Status.Wait:
            return t('WaitingVerification');
        default:
            return t('NotPass');
    }
}

  const getPictureStatusColor = (status) => {
    switch (status) {
        case Constants.Status.Yes:
            return 'success';
        case Constants.Status.No:
            return 'error';
        case Constants.Status.Wait:
            return 'warning';
        default:
            return 'error';
    }
}

  return (
    <div div className="ShearchContainer">
      <div className="ShearchDetailComponent">
        <span className="textHeader">{t("Detail")}</span>
      </div>
      <div style={{ padding: "0px 30px 15px 70px" }}>
        <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
        {getBillingRs?.billingDetailList?.map((item, index) => (
          <div>
            <div style={{ marginBottom: "15px" }}>
              <Grid container style={{ gap: "15px" }}>
                <Grid style={{ flexGrow: "1" }}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "15px",
                    }}
                  >
                    <TextDetail
                      title={t("DeliveryDate")}
                      value={`${ConvertDatetoFormatdateNormal(item?.deliveryDate)}`}
                      valueWidth={"100%"}
                      valueAlign={"left"}
                    />
                  </div>
                </Grid>
                <Grid style={{ flexGrow: "1" }}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "15px",
                    }}
                  >
                    <TextDetail
                      title={t("QueueNo")}
                      value={`${item?.qNo}`}
                      valueWidth={"100%"}
                      valueAlign={"left"}
                    />
                  </div>
                </Grid>
                <Grid style={{ flexGrow: "1" }}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "15px",
                    }}
                  >
                    <TextDetail
                      title={t("QueueStatus")}
                      value={`${item?.qStatus}`}
                    />
                    <TextDetail
                      title={t("PhotoStatus")}
                      value={getPictureStatusDesc(item?.pictureStatus)}
                      icon={<PhotoCameraOutlined color={getPictureStatusColor(item?.pictureStatus)}/>}
                    />
                  
                  </div>
                </Grid>
                <Grid
                  style={{
                    flexGrow: "5",
                    display: "flex",
                    alignItems: "flex-end",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "15px",
                      width: "100%",
                    }}
                  >
                    <TextDetail
                      title={t("EstimatedIncome")}
                      value={`${Number(item?.dropIncome).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')} ${t("Bath")}`}
                      valueAlign={"flex-end"}
                      valueWidth={"50%"}
                      titleWidth={"42%"}
                      titleAlign={"left"}
                    />
                  </div>
                </Grid>
              </Grid>
            </div>
            <div className="table-zone">
            <table style={{ width: "100%" }}>
              <thead>
                <tr
                  style={{
                    background: "#1976D2",
                    height: "40px",
                    color: "white",
                  }}
                >
                  {headersGroup?.map((item, index) => (
                    <th
                      key={index}
                      style={{
                        width: item.size,
                        textAlign: item.headerAlign,
                      }}
                    >
                      {item.headerName}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {item?.productDetail?.map((art, artIndex) => (
                  <tr
                    key={artIndex}
                    style={{
                      backgroundColor: artIndex % 2 === 0 ? "#E4EEFF" : "white",
                      height: "40px",
                    }}
                  >
                    <td style={{padding:"0px 20px"}}>
                    {
                      item.qChannel === Constants.QChannel.HomeRoute && !art.productID ?
                      art.packageID ? 
                      `${art?.packageID}`
                      : `${art?.eanNo ?? ''} ${art?.productName ?? ''}`
                      : `${parseInt(art?.productID)} ${art?.productName ?? ''}`
                    }
                    </td>
                    <td style={{textAlign:"center"}}>{`${art?.total} ${art?.unit}`}</td>
                    <td style={{textAlign:"center"}}>{`${art?.totalSuccess} ${art?.unit}`}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            </div>
          </div>
          ))}
        </div>
      </div>
      <CustomPagination
        page={page}
        pageSize={pageSize}
        pageCount={pageCount}
        totalRecordCount={totalRecordCount}
        onPageChange={(newPage) => {
          if (newPage !== page) {
            setPage(newPage);
            setIsClickSearch(true);
          }
        }}
        rowsPerPageOptions={[2, 5, 10, 20, 50]}
        onPageSizeChange={(newSize) => {
          if (newSize !== pageSize) {
            setPage(1);
            setPageSize(newSize);
            setIsClickSearch(true);
          }
        }}
      />
    </div>
  );
};

export default QueueDetail;
